var _ellipse, _ellipse2, _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _line, _line2, _ellipse3, _ellipse4, _g2, _rect5, _rect6, _rect7, _rect8, _path10, _path11, _path12, _path13, _path14, _path15, _line3, _line4, _path16, _path17, _circle, _circle2, _ellipse5, _path18, _path19, _ellipse6, _ellipse7, _ellipse8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 214,
    viewBox: "0 0 277 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3365,
    cy: 63.3221,
    rx: 61.3365,
    ry: 61.8292,
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1056_4209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 121,
    height: 121
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.3381,
    cy: 63.5687,
    rx: 58.8732,
    ry: 59.1195,
    fill: "white",
    stroke: "#282F34",
    strokeWidth: 2.25849
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1056_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.1182 78.5749C89.7605 76.2958 87.3035 74.8995 84.6506 74.8995H46.1713C43.7003 74.8995 41.3865 76.1122 39.9805 78.1442L14.6055 114.817C11.1507 119.81 14.7245 126.629 20.7964 126.629H106.497C112.339 126.629 115.955 120.266 112.965 115.248L91.1182 78.5749Z",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.619 16.6034C73.7463 6.63846 66.9733 7.66932 63.3944 10.4359C54.0894 17.6288 59.3367 31.0594 60.7254 36.3592C61.8364 40.599 72.3573 54.1452 69.5198 58.5569C90.9616 52.279 93.7097 29.0595 82.619 16.6034Z",
    fill: "#32374E",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6559 44.9935C28.1461 25.7415 33.2116 21.5971 37.095 22.1214C47.1915 23.4844 50.9953 44.0777 52.9498 51.6599C54.5135 57.7256 57.845 70.0749 46.3426 96.8615C42.2915 100.46 27.0432 69.0585 27.6559 44.9935Z",
    fill: "#32374E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 54.0928,
    y: 57.2561,
    width: 20.8077,
    height: 25.869,
    rx: 10.4038,
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 56.25,
    y: 51.8164,
    width: 18.8282,
    height: 23.4306,
    rx: 9.41409,
    fill: "#32374E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.3457,
    y: 33.6369,
    width: 10.685,
    height: 9.56028,
    rx: 4.78014,
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5322,
    y: 11.705,
    width: 39.9282,
    height: 56.7993,
    rx: 19.9641,
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5716 1.91004C48.929 4.15619 46.8978 9.46176 47.3917 13.189C48.676 22.8795 60.2869 24.6846 64.5909 25.8879C68.0341 26.8505 81.8741 24.9063 83.8305 28.7836C88.1345 10.7342 72.8749 -0.897647 59.5716 1.91004Z",
    fill: "#32374E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7695 10.2366C78.9031 7.72418 76.1533 9.57153 75.1447 11.5162C72.5227 16.5722 77.5001 21.3436 79.1667 23.3672C80.4999 24.986 87.8022 28.7192 87.4464 31.228C95.5488 24.0657 92.1024 13.377 84.7695 10.2366Z",
    fill: "#32374E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7133 11.278C50.6462 4.07828 55.8958 5.94131 58.0698 8.81873C63.7218 16.2997 55.8119 26.9793 53.2471 31.2926C51.1953 34.7433 38.9499 44.7544 40.0744 48.9256C24.2694 40.4595 28.2972 20.2777 40.7133 11.278Z",
    fill: "#32374E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6172 56.7698C68.9489 57.7043 64.5863 58.848 60.4824 55.9471",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5918 44.2853V47.3157C67.5918 48.0029 67.5918 49.8553 65.8699 49.8553",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2275 37.0428C76.3712 36.3405 74.3516 35.7498 73.1556 36.5608",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1934 36.8041C57.1263 36.2073 59.2013 35.8581 60.2937 36.8041",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2.25849,
    y1: -2.25849,
    x2: 3.23983,
    y2: -2.25849,
    transform: "matrix(-3.84519e-08 1 1 4.96901e-08 60.7178 39.8237)",
    stroke: "#32374E",
    strokeWidth: 4.51697,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.25849,
    y1: -2.25849,
    x2: 3.23983,
    y2: -2.25849,
    transform: "matrix(-3.84519e-08 1 1 4.96901e-08 77.2148 39.8237)",
    stroke: "#32374E",
    strokeWidth: 4.51697,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.4036,
    cy: 61.6176,
    rx: 61.4036,
    ry: 61.6176,
    transform: "matrix(-1 0 0 1 275 89.147)",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1056_4209",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 153,
    y: 91,
    width: 121,
    height: 121
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.8732,
    cy: 59.1195,
    rx: 58.8732,
    ry: 59.1195,
    transform: "matrix(-1 0 0 1 272.468 92.1421)",
    fill: "white",
    stroke: "#282F34",
    strokeWidth: 2.25849
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1056_4209)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.814 166.268C187.172 163.989 189.629 162.592 192.282 162.592H230.761C233.232 162.592 235.546 163.805 236.952 165.837L262.327 202.51C265.782 207.503 262.208 214.322 256.136 214.322H170.435C164.594 214.322 160.978 207.959 163.968 202.941L185.814 166.268Z",
    fill: "#32374E",
    stroke: "#32374E",
    strokeWidth: 2.25849
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 20.8077,
    height: 25.869,
    rx: 10.4038,
    transform: "matrix(-1 0 0 1 222.841 144.95)",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 18.8282,
    height: 23.4306,
    rx: 9.41409,
    transform: "matrix(-1 0 0 1 220.688 139.509)",
    fill: "#32374E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 10.685,
    height: 9.5603,
    rx: 4.78015,
    transform: "matrix(-1 0 0 1 238.587 121.331)",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 39.9282,
    height: 56.7993,
    rx: 19.9641,
    transform: "matrix(-1 0 0 1 232.401 99.398)",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M223.762 94.9598C216.49 93.7115 213.9 96.5183 213.294 98.9687C211.718 105.339 218.603 109.358 221.024 111.182C222.961 112.641 232.177 114.874 232.457 117.782C239.621 107.584 232.852 96.5203 223.762 94.9598Z",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M211.212 92.0408C221.206 94.1493 223.114 99.1298 222.65 102.629C221.444 111.725 210.54 113.42 206.499 114.549C203.265 115.453 190.268 113.628 188.431 117.268C184.389 100.324 198.719 89.4051 211.212 92.0408Z",
    fill: "white",
    stroke: "#32374E",
    strokeWidth: 2.25849
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M206.316 144.463C207.985 145.397 212.347 146.541 216.451 143.64",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M209.342 131.978V135.009C209.342 135.696 209.342 137.548 211.064 137.548",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M199.706 124.736C200.562 124.033 202.582 123.443 203.778 124.254",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.74 124.497C219.807 123.9 217.732 123.551 216.64 124.497",
    stroke: "#32374E",
    strokeWidth: 2.25849,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 218.474,
    y1: 129.776,
    x2: 218.474,
    y2: 130.758,
    stroke: "#32374E",
    strokeWidth: 4.51697,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 201.977,
    y1: 129.776,
    x2: 201.977,
    y2: 130.758,
    stroke: "#32374E",
    strokeWidth: 4.51697,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.752 100.032C171.879 100.812 175.941 104.569 176.822 109.681C177.435 113.243 177.961 117.768 177.961 122.818C177.961 127.869 177.435 132.394 176.822 135.956C176.066 140.344 172.966 143.733 168.859 145.099V155.425C168.859 157.774 166.305 159.232 164.282 158.037L145.729 147.074C139.011 146.964 132.988 146.288 128.493 145.605C123.366 144.824 119.303 141.067 118.423 135.956C117.809 132.394 117.284 127.869 117.284 122.818C117.284 117.768 117.809 113.243 118.423 109.68C119.303 104.569 123.366 100.812 128.493 100.032C133.406 99.2846 140.146 98.5476 147.622 98.5476C155.099 98.5476 161.839 99.2846 166.752 100.032Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M176.822 109.681L177.935 109.489H177.935L176.822 109.681ZM166.752 100.032L166.582 101.149L166.752 100.032ZM176.822 135.956L177.935 136.148H177.935L176.822 135.956ZM168.859 145.099H167.73V144.284L168.503 144.027L168.859 145.099ZM164.282 158.037L164.857 157.065L164.282 158.037ZM145.729 147.074L145.748 145.944L146.046 145.949L146.304 146.101L145.729 147.074ZM128.493 145.605L128.324 146.721L128.493 145.605ZM118.423 135.956L117.31 136.148L118.423 135.956ZM118.423 109.68L117.31 109.489V109.489L118.423 109.68ZM128.493 100.032L128.663 101.149L128.493 100.032ZM175.709 109.872C174.916 105.27 171.259 101.86 166.582 101.149L166.921 98.9157C172.499 99.7643 176.967 103.869 177.935 109.489L175.709 109.872ZM176.832 122.818C176.832 117.844 176.314 113.385 175.709 109.872L177.935 109.489C178.557 113.101 179.09 117.691 179.09 122.818H176.832ZM175.709 135.765C176.314 132.252 176.832 127.792 176.832 122.818H179.09C179.09 127.946 178.557 132.536 177.935 136.148L175.709 135.765ZM168.503 144.027C172.236 142.786 175.028 139.719 175.709 135.765L177.935 136.148C177.104 140.968 173.695 144.681 169.216 146.17L168.503 144.027ZM167.73 155.425V145.099H169.989V155.425H167.73ZM164.857 157.065C166.126 157.815 167.73 156.9 167.73 155.425H169.989C169.989 158.648 166.483 160.649 163.708 159.009L164.857 157.065ZM146.304 146.101L164.857 157.065L163.708 159.009L145.155 148.046L146.304 146.101ZM128.663 144.488C133.121 145.166 139.092 145.835 145.748 145.944L145.711 148.203C138.93 148.092 132.855 147.411 128.324 146.721L128.663 144.488ZM119.536 135.765C120.329 140.367 123.986 143.776 128.663 144.488L128.324 146.721C122.746 145.872 118.278 141.768 117.31 136.148L119.536 135.765ZM118.413 122.818C118.413 127.792 118.931 132.252 119.536 135.765L117.31 136.148C116.688 132.536 116.155 127.946 116.155 122.818H118.413ZM119.536 109.872C118.931 113.385 118.413 117.844 118.413 122.818H116.155C116.155 117.691 116.688 113.101 117.31 109.489L119.536 109.872ZM128.663 101.149C123.986 101.86 120.329 105.27 119.536 109.872L117.31 109.489C118.278 103.869 122.746 99.7643 128.324 98.9157L128.663 101.149ZM147.622 99.6768C140.217 99.6768 133.536 100.407 128.663 101.149L128.324 98.9157C133.276 98.1621 140.075 97.4183 147.622 97.4183V99.6768ZM166.582 101.149C161.709 100.407 155.028 99.6768 147.622 99.6768V97.4183C155.17 97.4183 161.969 98.1621 166.921 98.9157L166.582 101.149Z",
    fill: "#32374E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4565,
    cy: 4.4565,
    r: 4.4565,
    transform: "matrix(-1 0 0 1 165.278 117.402)",
    fill: "#8A68C8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4565,
    cy: 4.4565,
    r: 4.4565,
    transform: "matrix(-1 0 0 1 151.908 117.402)",
    fill: "#8A68C8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.4565,
    cy: 4.4565,
    rx: 4.4565,
    ry: 4.4565,
    transform: "matrix(-1 0 0 1 138.537 117.402)",
    fill: "#8A68C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.698 2.97743C109.57 3.75759 105.508 7.51471 104.627 12.6258C104.014 16.188 103.488 20.7131 103.488 25.7637C103.488 30.8143 104.014 35.3394 104.627 38.9015C105.383 43.289 108.484 46.6787 112.59 48.0441V58.3701C112.59 60.7192 115.145 62.1771 117.167 60.982L135.72 50.0189C142.438 49.9088 148.461 49.2338 152.956 48.5499C158.083 47.7698 162.146 44.0126 163.026 38.9015C163.64 35.3394 164.165 30.8143 164.165 25.7637C164.165 20.7131 163.64 16.188 163.026 12.6258C162.146 7.5147 158.083 3.75759 152.956 2.97743C148.043 2.22992 141.303 1.4929 133.827 1.4929C126.35 1.4929 119.61 2.22992 114.698 2.97743Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.627 12.6258L103.515 12.4341H103.515L104.627 12.6258ZM114.698 2.97743L114.868 4.09383L114.698 2.97743ZM104.627 38.9015L103.515 39.0932H103.515L104.627 38.9015ZM112.59 48.0441H113.719V47.2296L112.946 46.9726L112.59 48.0441ZM117.167 60.982L116.593 60.0098L117.167 60.982ZM135.72 50.0189L135.702 48.8898L135.403 48.8947L135.146 49.0467L135.72 50.0189ZM152.956 48.5499L153.126 49.6663L152.956 48.5499ZM163.026 38.9015L164.139 39.0932L163.026 38.9015ZM163.026 12.6258L164.139 12.4341V12.4341L163.026 12.6258ZM152.956 2.97743L152.786 4.09383L152.956 2.97743ZM105.74 12.8175C106.533 8.21552 110.19 4.80555 114.868 4.09383L114.528 1.86104C108.951 2.70963 104.483 6.81389 103.515 12.4341L105.74 12.8175ZM104.618 25.7637C104.618 20.7898 105.135 16.3299 105.74 12.8175L103.515 12.4341C102.892 16.046 102.359 20.6364 102.359 25.7637H104.618ZM105.74 38.7099C105.135 35.1974 104.618 30.7376 104.618 25.7637H102.359C102.359 30.891 102.892 35.4813 103.515 39.0932L105.74 38.7099ZM112.946 46.9726C109.213 45.7312 106.421 42.6647 105.74 38.7099L103.515 39.0932C104.345 43.9133 107.754 47.6262 112.234 49.1157L112.946 46.9726ZM113.719 58.3701V48.0441H111.461V58.3701H113.719ZM116.593 60.0098C115.323 60.7601 113.719 59.8448 113.719 58.3701H111.461C111.461 61.5936 114.966 63.5941 117.742 61.9542L116.593 60.0098ZM135.146 49.0467L116.593 60.0098L117.742 61.9542L136.295 50.9911L135.146 49.0467ZM152.786 47.4335C148.329 48.1117 142.357 48.7808 135.702 48.8898L135.739 51.148C142.519 51.0369 148.594 50.3558 153.126 49.6663L152.786 47.4335ZM161.913 38.7099C161.121 43.3118 157.464 46.7218 152.786 47.4335L153.126 49.6663C158.703 48.8177 163.171 44.7135 164.139 39.0932L161.913 38.7099ZM163.036 25.7637C163.036 30.7376 162.518 35.1974 161.913 38.7099L164.139 39.0932C164.761 35.4813 165.294 30.891 165.294 25.7637H163.036ZM161.913 12.8175C162.518 16.3299 163.036 20.7898 163.036 25.7637H165.294C165.294 20.6364 164.761 16.046 164.139 12.4341L161.913 12.8175ZM152.786 4.09383C157.464 4.80555 161.121 8.21552 161.913 12.8175L164.139 12.4341C163.171 6.81389 158.703 2.70963 153.126 1.86104L152.786 4.09383ZM133.827 2.62214C141.232 2.62214 147.913 3.3524 152.786 4.09383L153.126 1.86104C148.173 1.10744 141.375 0.363654 133.827 0.363654V2.62214ZM114.868 4.09383C119.74 3.3524 126.421 2.62214 133.827 2.62214V0.363654C126.279 0.363654 119.481 1.10744 114.528 1.86104L114.868 4.09383Z",
    fill: "#32374E"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.627,
    cy: 24.8039,
    rx: 4.4565,
    ry: 4.4565,
    fill: "#8A68C8"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 133.998,
    cy: 24.8039,
    rx: 4.4565,
    ry: 4.4565,
    fill: "#8A68C8"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 147.369,
    cy: 24.8039,
    rx: 4.4565,
    ry: 4.4565,
    fill: "#8A68C8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5244,
    y: 142.395,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1035,
    y: 142.395,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "#DADADA"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6875,
    y: 142.395,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5244,
    y: 156.824,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "#DADADA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1035,
    y: 156.824,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6875,
    y: 156.824,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "#DADADA"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 108.267,
    y: 156.824,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 81.1035,
    y: 171.253,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "#DADADA"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 94.6826,
    y: 171.253,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 108.267,
    y: 171.253,
    width: 6.79023,
    height: 6.79022,
    rx: 3.39511,
    fill: "#DADADA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactAdmin);
export default __webpack_public_path__ + "static/media/contact-admin.e8f3b6f8448d2c736939edf7148f1c20.svg";
export { ForwardRef as ReactComponent };